import { createSelector } from 'reselect';
import { AppState } from '../..';

export const selectLoading = createSelector(
  (state: AppState) => state.notifications.isLoading,
  (loading) => loading,
);

export const selectSubscriptionPortalUrl = (state: AppState) =>
  state.subscriptions.portalUrl;

export const getIsShowingSubscriptionSuccess = createSelector(
  (state: AppState) => state.subscriptions,
  (subs) => subs.showSubscriptionSuccess,
);
